import React from "react";
import ReactDOM from "react-dom";
import "./Index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from 'react-router-dom'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  // useResolvedPath
} from "react-router-dom";
import "./Index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Survey from "./Survey";
import { Container, Row, Col } from 'react-grid-system';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Input,
  Grid,
  FormHelperText,
  Button
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { Hidden } from '@material-ui/core';
import DialogActions from "@material-ui/core/DialogActions";
import { GREY, RED, LIGHTBLUE, LIGHTGREY } from "../../utils/color_utils";
import SendIcon from "@material-ui/icons/Send";
import { showToast } from "../../store/actions/toastAction";
import { createSurvey } from "../../store/actions/SurveyActions";
import { updateSurvey } from "../../store/actions/surveyUpdate";
import { surveyStats } from "../../store/actions/surveyStatsAction";
import { simpleAction } from "../../store/actions/simpleAction";
import { surveyTestsDisplay } from "../../store/actions/surveyTestsDisplayAction";
import firebase from "../../store/firebase";
import { connect } from "react-redux";
import {
  SURVEY_LIST,
  UPDATE_SURVEY,
  SURVEY_STATS_LIST,
  SIMPLE_VALUES,
  SURVEY_TESTS_LIST
} from "../../store/actions/types";
import { array } from "prop-types";
import survey from './img/surveypic.jpg';
import './sidebar.css'; 
import { blue } from "@material-ui/core/colors";
import { getPassingThreshold, calculateTestPassed, calculateLCEarned, getDifficultyInfo } from '../../utils/test_utils';


const sendBtn = {
  backgroundColor: LIGHTBLUE,
  color: "#fff"
};
const sendBtn2 = {
  backgroundColor: RED,
  color: "#fff"
};
const table = {
    color: "#515A5A",
    fontSize: 14,
    border: "0px",
    //border: "1px solid #CAC9C8",
    backgroundColor: '#F2F3F4',
    padding: 1,
    borderRadius: 2
}
const tableh = {
  color: "#f2f3f3",
  fontSize: 14,
  //border: "1px solid #707B7C",
  border: "0px",
  backgroundColor: '#acb3b9',
  padding: 2,
  borderRadius: 2
}
const tableM = {
  color: "#515A5A",
  fontSize: 18,
  //border: "1px solid #707B7C",
  border: "0px",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 2
}

const styles = {
  mlist: {
    width: 250,
    // backgroundColor: 'red',
  },
  survs: {
    width: 1500,
    // backgroundColor: 'blue',
  },
  row2: {
//     backgroundColor: 'green',
  },
  col1: {
    backgroundColor: 'yellow',
  },
  col2: {
    backgroundColor: 'brown',
  },
  col: {
    padding: '1rem',
    backgroundColor: '#33b5e5',
    border: '2px solid #fff',
    color: '#fff',
    textAlign: 'center'
    }
};

// class Surveys extends React.Component {
//   constructor (props) {
//      super(props);
//   }

//   state = {
//     surveysLoaded: this.props.update_Survey,
//     showPic: true,
//     groupname: "",
//     groupid: "",
//     defaultgroup: "Select Group",
//     gr: ""
//    // surveylist: ""
//   }


//   componentDidMount() {

//     // var database = firebase.database;
//     // database
//     //   .ref("company_user_groups/" + this.props.userdata.userID)
//     //   .once("value")
//     //   .then(snapshot => {
//     //     const groupsArr = [];

//     //     snapshot.forEach(childSnapshot => {
//     //       groupsArr.push({
//     //         id: childSnapshot.key,
//     //         group_id: childSnapshot.val().group_id,
//     //         group_name: childSnapshot.val().group_name
//     //       });
//     //     });
//     //     this.setState({ gr: groupsArr });
//     //   });
//   }

//   functionTwo = (var1, callback) => {
//     callback(var1);
//    }

//     objsize = (Myobj) => {
//       var osize = 0, key;
//       for (key in Myobj) {
//           if (Myobj.hasOwnProperty(key)) osize++;
//       }
//       return osize;
//     };

//     getKeys(object) {
//       function iter(o, p) {
//           if (Array.isArray(o)) { return; }
//           if (o && typeof o === 'object') {
//               var keys = Object.keys(o);
//               if (keys.length) {
//                   keys.forEach(function (k) { iter(o[k], p.concat(k)); });
//               }
//               return;
//           }
//           result.push(p.join('.'));
//       }
//       var result = [];
//       iter(object, []);
//       return result;
//   }

//   hidePic = (cond) => {
//     if (cond) {
//       this.setState({showPic:true});
//     }
//     else {
//      this.setState({showPic:false});
//     }
//   }

//   getS = (surid, groupid) => {
//     var body = {
//       type: SURVEY_STATS_LIST,
//       companyID: this.props.userdata.companyID,
//       surveyid: surid, 
//       groupID: groupid //this.state.mgroup.id
//       }

//    this.props.surveyStats(body); 

//  }

//   render(){
//   const { update_Survey, surveyStats, survey_stats_list, surveyTestsDisplay, survey_tests_list, simpleAction } = this.props;
//   return (
//     <Router>
//       <div className="sidebar">
//       <Container>
//         <Row>
//           <Col sm={2}>
//             <Row style={tableh}><b>
//             <OldSchoolMenuLink 
//               to="CreateaSurvey" 
//               label="Make survey" 
//             />
//             </b></Row>
//             {/* <Row style={{border: "1px solid rgb(194, 36, 7)"}}> */}
//             <Row style={tableh}>
//           <div>

//          <React.Fragment>
       
//         {/* SURVEY LINKS 1 */}

//         { update_Survey && Object.keys(update_Survey).map((QandA, id) => {
//               return (            
//                     <OldSchoolMenuLink
//                       key={update_Survey[QandA].surveyid.toString()}
//                       activeOnlyWhenExact={true}
//                       to={update_Survey[QandA].surveyid}
//                       label={update_Survey[QandA].title}
//                   />
//                  );
//               }) 
//             }

//            </React.Fragment>

//           </div>
//           </Row>
//           {/* <Row><b>STATS</b></Row> */}
//           {/* <Row style={{border: "1px solid rgb(194, 36, 7)"}} > */}
//           <Row style={tableh}>
//           <Col sm={8}>
//           <FormControl style={{minWidth: 100, maxWidth: 120}}> 
//           {/* <InputLabel shrink htmlFor="age-native-label-placeholder">
//             Enter Relevant Group
//           </InputLabel> */}
//           <Select
//               label="Group"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({groupname: value, groupid: value.id});

//                 var body;
//                // update_Survey && Object.keys(update_Survey).map((QandA, id) => 
//                 body = {
//                   type: SURVEY_STATS_LIST,
//                   companyID: this.props.userdata.companyID,
//                   surveyid: this.props.simplething, //this.props.surveyid, 
//                   groupID: value.id //this.state.mgroup.id
//                   }
//                 this.props.surveyStats(body)
//                // )
//               }}

//                 // var body = {
//                 //   type:
//                 //   groupID: value      
//                 //   }
//                 // this.props.simpleAction(body);  

//               value={this.state.groupname}
//               displayEmpty
//               input={<Input name="survey" id="survey" value={this.state.groupname} />}
//             >
//               <MenuItem value={this.state.groupname}>
//                 <em>{this.state.defaultgroup}</em>
//               </MenuItem>

//               {this.state.gr
//                   ? this.state.gr.map(item => {
//                     return (
//                       <MenuItem value={item}>{item.group_name}</MenuItem>
//                     );
//                   })
//                   : null}
//             </Select>
//             </FormControl>
//           </Col>
//           </Row>
//           {/* <Row style={{border: "1px solid rgb(100, 68, 64)"}} ><b> */}
//           <Row style={tableh}><b>
//             {/* <OldSchoolMenuLink 
//               to="SurveyAllStats" 
//               label="Survey Stats" 
//             /> */}
//           {/* SURVEY STATS LINKS 1 */}
//           { update_Survey && Object.keys(update_Survey).map((QandA, id) => {
//                 return (            
//                       <OldSchoolMenuLink
//                         key={update_Survey[QandA].surveyid.toString()}
//                         activeOnlyWhenExact={true}
//                         to={'x'+update_Survey[QandA].surveyid}
//                         label={update_Survey[QandA].title}
//                     />
//                     );
//                   }) 
//                 }

//             </b></Row>
//           </Col>

//           <Col style={styles.survs}>
//             <Switch>
//               <Route exact path="/createaSurvey">
//                 <CreateaSurvey letgoPic={this.hidePic} key={this.props} props={this.props}/>
//               </Route>

//               {/* SURVEY STATS LINKS 2 */}
//               {update_Survey && Object.keys(update_Survey).map((QandA, id) => {
//                 const magicpath = "/x"+update_Survey[QandA].surveyid;

//                 // var body = {
//                 //   type: SIMPLE_VALUES,
//                 //   surveyid: update_Survey[QandA].surveyid 
//                 // }

//                 return (
//                   <Route exact path={magicpath}>
//                    <SurveyAllStats
//                       key={update_Survey[QandA].surveyid}
//                       surveyid={update_Survey[QandA].surveyid} 
//                       surveyType={update_Survey[QandA].type}
//                       letgoPic={this.hidePic} 
//                       surveyStats={surveyStats} 
//                       simpleAction={simpleAction}
//                       surveyTestsDisplay={surveyTestsDisplay}
//                       survey_stats_list={survey_stats_list} 
//                       survey_tests_list={this.props.survey_tests_list}
//                       companyID={this.props.userdata.companyID} 
//                       //groupID={this.props.rgroupid}
//                       groupidx={this.state.groupname}
//                       groupid={this.state.groupid}
//                       //getS={this.getS}
//                       // onClick={event => {
//                       // }}
//                       //onClick={() => {this.props.simpleAction(body)}}
//                    />  
//                    </Route>            
//                     );
//                   }) 
//                 }                                                                                                          
//             {/* SURVEY LINKS 2 */}
//             { update_Survey && Object.keys(update_Survey).map((QandA, id) => {
//              const magicpath = "/"+update_Survey[QandA].surveyid;

//               return (
//                 <Route exact path={magicpath}>
//                   <div>
//                     <h2>{update_Survey[QandA].title}</h2>
//                     <Survey 
//                       letgoPic={this.hidePic} 
//                       personid={this.props.userdata.userID} 
//                       key={update_Survey[QandA].surveyid} 
//                       companyID={this.props.userdata.companyID} 
//                       surveyid={update_Survey[QandA].surveyid} 
//                       typeofSurvey={update_Survey[QandA].type} 
//                       size={update_Survey[QandA].size}
//                     />
//                   </div>
//                 </Route>                    
//                   );
//                 }) 
//               }                                          
//             </Switch>
//           </Col>
//          { this.state.showPic===true? <div className="howpic"><Col><div align="left"><img width="700px" height={500} alt="" src={survey} /></div></Col></div> 
//           :null
//          } 
//         </Row>
//       </Container>
//       </div>
//     </Router>
//   );
//  }
// }

function OldSchoolMenuLink({ label, to, activeOnlyWhenExact }) {
  var tutu="/"+to;
  let match = useRouteMatch({
    path: tutu,
    exact: activeOnlyWhenExact
  });

  return (
    <div className={match ? "active" : ""}>
      {match && ">> "}
      <Link to={tutu}>{label}</Link>
    </div>
  );
}

function handleChange() {
  
}
function swapStuff(str) {
  var c, cc;
    c = str.replace(/\./g, (i => _ => ' ?'[i = 1 - i])(1));
    cc = c.replace(/\,/g, (i => _ => ' ?'[i = 1 - i])(1));
    cc = cc.replace(/\’/g, (i => _ => '?'[i = 1 - i])(1));
    cc = cc.replace(/\?/g, (i => _ => ' ?'[i = 1 - i])(1));
    
   // cc = cc.replace(/.$/," ");

  return cc;
 }

// class CreateaSurvey extends React.Component {
//     constructor (props) {   
//       super(props);
//       this.props.letgoPic(false);
//     }

//     state = {
//       stitle: '',
//       companyid: this.props.props.userdata.companyID,
//       Qnumber: 0,
//       sQuestion: '',
//       sAnswer1: '',
//       sAnswer2: '',
//       sAnswer3: '',
//       sAnswer4: '',
//       sAnswer5: '',
//       QandA1: [],
//       QandA2: [],
//       QandA3: [],
//       QandA4: [],
//       QandA5: [],
//       QandA6: [],
//       QandA7: [],
//       QandA8: [],
//       QandA9: [],
//       QandA10: [],
//       QandA11: [],
//       QandA12: [],
//       typeofsurvey: "",
//       defaultsurvey: "Select Survey type",
//       focus: true
//     }

//   selectSurveyType = (event, name) => {
//     //this.setState({ typeofsurvey: name.props.value });
//     //this.setState({ typeofsurvey: typeofsurvey[0].value })
//   }
 
//   stop = (nrIn, val) => {
//     var body = {
//       type: SURVEY_LIST,
//       title: this.state.stitle,
//       companyID: this.state.companyid,
//       typeofSurvey: this.state.typeofsurvey,
//       size: this.state.Qnumber,
//       QandA1: (nrIn===1 ? val:this.state.QandA1),
//       QandA2: (nrIn===2 ? val:this.state.QandA2),
//       QandA3: (nrIn===3 ? val:this.state.QandA3),
//       QandA4: (nrIn===4 ? val:this.state.QandA4),
//       QandA5: (nrIn===5 ? val:this.state.QandA5),
//       QandA6: (nrIn===6 ? val:this.state.QandA6),
//       QandA7: (nrIn===7 ? val:this.state.QandA7),
//       QandA8: (nrIn===8 ? val:this.state.QandA8),
//       QandA9: (nrIn===9 ? val:this.state.QandA9),
//       QandA10: (nrIn===10 ? val:this.state.QandA10),
//       QandA11: (nrIn===11 ? val:this.state.QandA11),
//       QandA12: (nrIn===12 ? val:this.state.QandA12)
//     };
    
//     this.props.props.createSurvey(body);

//     this.setState({stitle: "", typeofsurvey: 0, Qnumber: 1000});
//     this.props.letgoPic(true);
//   }

//   submitPost = (desc) => {
//     var arrAnswer1 = [];
//     var arrAnswer2 = [];
//     var arrAnswer3 = [];
//     var arrAnswer4 = [];
//     var arrAnswer5 = [];
//     var arrAnswer6 = []; 
//     var arrAnswer7 = [];
//     var arrAnswer8 = [];
//     var arrAnswer9 = [];
//     var arrAnswer10 = [];
//     var arrAnswer11 = [];
//     var arrAnswer12 = [];
//     var arrQandA = [];

//    var qq = this.state.Qnumber + 1;

//    this.setState({Qnumber: qq});
//    var arrQandA = []; //{}; //new Array();
//    var arrAnswer = []; //{};
//    var Qnum = this.state.Qnumber;
//    var lastQ;

//    //var Qlimit = this.state.Qnumber;

//   //  if (desc === 2) {
//   //    Qnum = 12

//   //   }

//    switch (Qnum) {
//     case 1000:
//       break;
//     case 0: // survey basic details
//       this.setState({
//         title: this.state.stitle,
//         companyID: this.state.companyid 
//       })
//       break;
//     case 1: // build arrays for all other cases
//     arrAnswer1 = {
//       "question": this.state.sQuestion,
//       "a1": this.state.sAnswer1,
//       "a2": this.state.sAnswer2,
//       "a3": this.state.sAnswer3,
//       "a4": this.state.sAnswer4,
//       "a5": this.state.sAnswer5
//     };
//     this.setState({QandA1: arrAnswer1});
//     if ( desc === 2 && Qnum === 1 ) {
//       this.stop(1, arrAnswer1)
//     }
//       break;
//     case 2: // build arrays for all other cases
//     arrAnswer2 = {
//       "question": this.state.sQuestion,
//       "a1": this.state.sAnswer1,
//       "a2": this.state.sAnswer2,
//       "a3": this.state.sAnswer3,
//       "a4": this.state.sAnswer4,
//       "a5": this.state.sAnswer5
//     };
//     this.setState({QandA2: arrAnswer2});
//     if ( desc === 2 && Qnum === 2 ) {
//       this.stop(2, arrAnswer2)
//     }
//       break;
//     case 3: // build arrays for all other cases
//     arrAnswer3 = {
//       "question": this.state.sQuestion,
//       "a1": this.state.sAnswer1,
//       "a2": this.state.sAnswer2,
//       "a3": this.state.sAnswer3,
//       "a4": this.state.sAnswer4,
//       "a5": this.state.sAnswer5
//     };
//     if ( desc === 2 && Qnum === 3 ) {
//       this.stop(3, arrAnswer3)
//     }
//     this.setState({QandA3: arrAnswer3});
//       break; 
//     case 4: // build arrays for all other cases
//     arrAnswer4 = {
//       "question": this.state.sQuestion,
//       "a1": this.state.sAnswer1,
//       "a2": this.state.sAnswer2,
//       "a3": this.state.sAnswer3,
//       "a4": this.state.sAnswer4,
//       "a5": this.state.sAnswer5
//     };
//     this.setState({QandA4: arrAnswer4});
//     if ( desc === 2 && Qnum === 4 ) {
//       this.stop(4, arrAnswer4)
//     }
//       break;  
//    case 5: // build arrays for all other cases
//     arrAnswer5 = {
//       "question": this.state.sQuestion,
//       "a1": this.state.sAnswer1,
//       "a2": this.state.sAnswer2,
//       "a3": this.state.sAnswer3,
//       "a4": this.state.sAnswer4,
//       "a5": this.state.sAnswer5
//     };
//     this.setState({QandA5: arrAnswer5});
//     if ( desc === 2 && Qnum === 5 ) {
//       this.stop(5, arrAnswer5)
//     }
//       break;    
//    case 6: // build arrays for all other cases
//       arrAnswer6 = {
//         "question": this.state.sQuestion,
//         "a1": this.state.sAnswer1,
//         "a2": this.state.sAnswer2,
//         "a3": this.state.sAnswer3,
//         "a4": this.state.sAnswer4,
//         "a5": this.state.sAnswer5
//       };
//       this.setState({QandA6: arrAnswer6});
//       if ( desc === 2 && Qnum === 6 ) {
//         this.stop(6, arrAnswer6)
//       }
//         break;      
//    case 7: // build arrays for all other cases
//         arrAnswer7 = {
//           "question": this.state.sQuestion,
//           "a1": this.state.sAnswer1,
//           "a2": this.state.sAnswer2,
//           "a3": this.state.sAnswer3,
//           "a4": this.state.sAnswer4,
//           "a5": this.state.sAnswer5
//         };
//         this.setState({QandA7: arrAnswer7});
//         if ( desc === 2 && Qnum === 7 ) {
//           this.stop(7, arrAnswer7)
//         }
//           break;       
//    case 8: // build arrays for all other cases
//           arrAnswer8 = {
//             "question": this.state.sQuestion,
//             "a1": this.state.sAnswer1,
//             "a2": this.state.sAnswer2,
//             "a3": this.state.sAnswer3,
//             "a4": this.state.sAnswer4,
//             "a5": this.state.sAnswer5
//           };
//           this.setState({QandA8: arrAnswer8});
//           if ( desc === 2 && Qnum === 8 ) {
//             this.stop(8, arrAnswer8)
//           }
//             break; 
//    case 9: // build arrays for all other cases
//           arrAnswer9 = {
//             "question": this.state.sQuestion,
//             "a1": this.state.sAnswer1,
//             "a2": this.state.sAnswer2,
//             "a3": this.state.sAnswer3,
//             "a4": this.state.sAnswer4,
//             "a5": this.state.sAnswer5
//           };
//           this.setState({QandA9: arrAnswer9});
//           if ( desc === 2 && Qnum === 9 ) {
//             this.stop(9, arrAnswer9)
//           }
//             break; 
//     case 10: // build arrays for all other cases
//           arrAnswer10 = {
//             "question": this.state.sQuestion,
//             "a1": this.state.sAnswer1,
//             "a2": this.state.sAnswer2,
//             "a3": this.state.sAnswer3,
//             "a4": this.state.sAnswer4,
//             "a5": this.state.sAnswer5
//           };
//           this.setState({QandA10: arrAnswer10});
//           if ( desc === 2 && Qnum === 10 ) {
//             this.stop(10, arrAnswer10)
//           }
//             break; 
//      case 11: // build arrays for all other cases
//             arrAnswer11 = {
//               "question": this.state.sQuestion,
//               "a1": this.state.sAnswer1,
//               "a2": this.state.sAnswer2,
//               "a3": this.state.sAnswer3,
//               "a4": this.state.sAnswer4,
//               "a5": this.state.sAnswer5
//             };
//             this.setState({QandA11: arrAnswer11});
//             if ( desc === 2 && Qnum === 11 ) {
//               this.stop(11, arrAnswer11)
//             }
//               break;              
//     case 12: // last question, submit all 
//       arrAnswer12 = {
//         "question": this.state.sQuestion,
//         "a1": this.state.sAnswer1,
//         "a2": this.state.sAnswer2,
//         "a3": this.state.sAnswer3,
//         "a4": this.state.sAnswer4,
//         "a5": this.state.sAnswer5
//       };
//       this.setState({QandA12: arrAnswer12});
//       if ( desc === 2 && Qnum === 12 ) {
//         this.stop(12, arrAnswer12)
//       }
//       // lastQ = "QandA" + this.state.Qnumber
//       // this.setState({[lastQ]: arrAnswer12});
//       // if (this.state.Qnumber != 12) {arrAnswer12=[]}

//       // var body = {
//       //   type: SURVEY_LIST,
//       //   title: this.state.stitle,
//       //   companyID: this.state.companyid,
//       //   typeofSurvey: this.state.typeofsurvey,
//       //   size: this.state.Qnumber,
//       //   QandA1: this.state.QandA1,
//       //   QandA2: this.state.QandA2,
//       //   QandA3: this.state.QandA3,
//       //   QandA4: this.state.QandA4,
//       //   QandA5: this.state.QandA5,
//       //   QandA6: this.state.QandA6,
//       //   QandA7: this.state.QandA7,
//       //   QandA8: this.state.QandA8,
//       //   QandA9: this.state.QandA9,
//       //   QandA10: this.state.QandA10,
//       //   QandA11: this.state.QandA11,
//       //   QandA12: arrAnswer12
//       // };

//       // this.props.props.createSurvey(body);

//       // this.setState({stitle: "", typeofsurvey: 0, Qnumber: 1000});
//       // this.props.letgoPic(true);
//       break;

//     default: // build arrays for all other cases
//    }
//    this.setState({
//     sQuestion: '',
//     sAnswer1: '',
//     sAnswer2: '',
//     sAnswer3: '',
//     sAnswer4: '',
//     sAnswer5: '',
//    })
//   }

//   componentDidMount() {
//    this.setState({defaultsurvey: "Select Survey Type"});
//   }

//   render() {

//   return (
//     <div className="bod">
//       <Container>
//       { this.state.Qnumber===0 ?
//       <React.Fragment>
//       <h2>New Survey</h2> 
//       <Row>
//         <Col sm={12}>
//           <TextField
//                 autoFocus
//                 id="title"
//                 label="Enter Title"
//                 multiline
//                 fullWidth
//                 margin="normal"
//                 InputLabelProps={{
//                   shrink: true
//                 }}
//                 inputProps={{ maxLength: 200 }}
//                 aria-describedby="surveyTitle"
//                 onChange={event => {
//                   const { value } = event.target;
//                   this.setState({stitle: swapStuff(value)})
//                 }}
//                 value={swapStuff(this.state.stitle)}
//               />
//         </Col>
//       </Row>

//       <Row>
//         <Col sm={12}>
//         <FormControl style={{minWidth: 160}}> 
//         <InputLabel shrink htmlFor="age-native-label-placeholder">
//           Enter Type of Survey
//         </InputLabel>
//          <Select
//             label="Type of Survey"
//             onChange={event => {
//               const { value } = event.target;
//               this.setState({typeofsurvey: value})
//             }}
//             value={this.state.typeofsurvey}
//             displayEmpty
//             input={<Input name="survey" id="survey" value={this.state.typeofsurvey} />}
//           >
//             <MenuItem value={this.state.typeofsurvey}>
//               <em>{this.state.defaultsurvey}</em>
//             </MenuItem>
//             <MenuItem value='P'>
//               <em>Poll</em>
//             </MenuItem>
//             <MenuItem value='T'>
//               Test
//             </MenuItem>
//           </Select>
//           </FormControl>
//         </Col>
//         </Row>
//         </React.Fragment> 
//         :
//          this.state.Qnumber < 13 ?
//         <React.Fragment> 
//         <h2>Survey Builder</h2> 
//         <Row>
//         <Col sm={12}>
//           <TextField
//               autoFocus={this.state.focus}
//               id="sQuestion"
//               label={"Enter Question "+this.state.Qnumber}
//               multiline
//               fullWidth
//               margin="normal"
//               InputLabelProps={{
//                 shrink: true
//               }}
//               inputProps={{ maxLength: 200 }}
//               aria-describedby="surveyTitle"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({sQuestion: swapStuff(value)})
//               }}
//               value={swapStuff(this.state.sQuestion)}
//             />
//         </Col>
//       </Row>  
//        <Row>
//        </Row>
//        <Row>
//         <Col sm={10}>
//           <TextField
//               // autoFocus
//               id="sAnswer1"
//               label="Enter Answer 1"
//               multiline
//               fullWidth
//               margin="normal"
//               InputLabelProps={{
//                 shrink: true
//               }}
//               inputProps={{ maxLength: 200 }}
//               aria-describedby="answer"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({sAnswer1: swapStuff(value)})
//               }}
//               value={swapStuff(this.state.sAnswer1)}
//             />
//         </Col>
//       </Row> 
//       <Row>
//         <Col sm={10}>
//           <TextField
//               // autoFocus
//               id="sAnswer2"
//               label="Enter Answer 2"
//               multiline
//               fullWidth
//               margin="normal"
//               InputLabelProps={{
//                 shrink: true
//               }}
//               inputProps={{ maxLength: 200 }}
//               aria-describedby="answer"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({sAnswer2: swapStuff(value)})
//               }}
//               value={swapStuff(this.state.sAnswer2)}
//             />
//         </Col>
//       </Row> 
//       <Row>
//         <Col sm={10}>
//           <TextField
//               // autoFocus
//               id="sAnswer3"
//               label="Enter Answer 3"
//               multiline
//               fullWidth
//               margin="normal"
//               InputLabelProps={{
//                 shrink: true
//               }}
//               inputProps={{ maxLength: 200 }}
//               aria-describedby="answer"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({sAnswer3: swapStuff(value)})
//               }}
//               value={swapStuff(this.state.sAnswer3)}
//             />
//         </Col>
//       </Row> 
//       <Row>
//         <Col sm={10}>
//           <TextField
//               // autoFocus
//               id="sAnswer4"
//               label="Enter Answer 4"
//               multiline
//               fullWidth
//               margin="normal"
//               InputLabelProps={{
//                 shrink: true
//               }}
//               inputProps={{ maxLength: 200 }}
//               aria-describedby="answer"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({sAnswer4: swapStuff(value)})
//               }}
//               value={swapStuff(this.state.sAnswer4)}
//             />
//         </Col>
//       </Row> 

//   { this.state.typeofsurvey==="T"?
//       <Row>
//         <Col sm={10}>
//           <TextField
//               // autoFocus
//               id="sAnswer5"
//               label="Enter Correct Answer 5"
//               multiline
//               fullWidth
//               margin="normal"
//               InputLabelProps={{
//                 shrink: true
//               }}
//               inputProps={{ maxLength: 200 }}
//               aria-describedby="answer"
//               onChange={event => {
//                 const { value } = event.target;
//                 this.setState({sAnswer5: swapStuff(value)})
//               }}
//               value={swapStuff(this.state.sAnswer5)}
//             />
//         </Col>
//       </Row> 
//      :
//      <Row>
//      <Col sm={10}>
//      <input type="hidden"
//            id="sAnswer5"
//            aria-describedby="answer"
//            value="no answer"
//          />
//      </Col>
//    </Row> 
//      }
//       </React.Fragment> 
//        :null
//         // OR 
//         // PUT IN SOME NICE MESSAGE
//         }
//         { this.state.Qnumber < 13 ?
//         <Row>
//          <Col sm={8}></Col>
//         <Col sm={8}>
//         <FormControl>
         
//           <DialogActions>
//             {this.state.Qnumber < 12? 
//               <Button
//                 variant="contained"
//                 onClick={() => this.submitPost(1)}
//                 style={sendBtn}
//               >
//                 <SendIcon/>
//                 CONTINUE
//               </Button>
//              :null}
//              {this.state.Qnumber > 0?
//               <Button
//                 variant="contained"
//                 onClick={() => this.submitPost(2)}
//                 style={sendBtn2}
//               >
//                 <SendIcon/>
//                 END
//               </Button>
//               :null}
//             </DialogActions>
//           </FormControl>
//         </Col>
//       </Row>
//       :null}
//     </Container>
//     </div>
//   );
//   }
//  }

 class SurveyAllStats extends React.Component {
  constructor (props) {
     super(props);
    // this.props.letgoPic(false);
  }

  state = {
    showPic: false,
    mgroupid: this.props.groupID,
    mgroupname: this.props.title,
    surveyMetadata: null // Store survey metadata including testComplexity
  }

  trimStripe(strIn){
    var str = strIn;
   return strIn;
  }

  componentDidMount() {
    
    this.getS();
    this.fetchSurveyMetadata();
   }

    getS = () => {
      var booty = {
        type: SURVEY_TESTS_LIST,
        companyID: this.props.companyID,
        surveyid: this.props.surveyid, 
        groupID: this.props.groupID, //this.state.mgroup.id
        surveyTitle: this.props.surveyTitle,
        personid: this.props.personid,
        size: this.props.size
        }
        
        this.props.surveyTestsDisplay(booty); 

      var body = {
        type: SURVEY_STATS_LIST,
        companyID: this.props.companyID,
        surveyid: this.props.surveyid, 
        groupID: this.props.groupID, //this.state.mgroup.id
        personid: this.props.personid,
        size: this.props.size
        }
        
        this.props.surveyStats(body); 

      var body = {
        type: SIMPLE_VALUES,
        surveyid: this.props.surveyid      
        }
      this.props.simpleAction(body);

      
      
   }

   // Fetch survey metadata including difficulty
   fetchSurveyMetadata = () => {
     if (this.props.companyID && this.props.surveyid) {
       firebase.database.ref(`surveys/${this.props.companyID}/${this.props.surveyid}`).once("value")
         .then(snapshot => {
           const surveyData = snapshot.val();
           
           this.setState({ surveyMetadata: surveyData });
         })
         .catch(error => {
           
         });
     }
   }

   truncate(str){
    return str.length > 10 ? str.substring(0, 7) + "..." : str;
   } 

   componentWillReceiveProps(nextProps) {
    this.setState({ 
      mgroup: nextProps.groupidx
     }); 
   }

  render(){
    const { survey_stats_list, survey_tests_list } = this.props;
    const { surveyMetadata } = this.state;
    
    
    
    

    const getPercentageScore = (score, qlen) => {
      
      var x = (score/qlen)*100;
      

      var y;
      if (x!=undefined) {
        y = x;
      }
      else {
        y = 0;
      }
      return y.toFixed(1)+'%';
    }

    // Get default test difficulty from survey metadata (used only for header copy)
    const defaultDifficulty = surveyMetadata?.testComplexity || 'basic';
    const difficultyInfo = getDifficultyInfo(defaultDifficulty);

    // Filter out any non-user or malformed entries to avoid undefined rows
    const rawEntries = survey_tests_list ? Object.values(survey_tests_list) : [];
    const validEntries = rawEntries.filter(u => {
      if (!u || typeof u !== 'object') return false;
      const hasPersonId = typeof u.personid === 'string' && u.personid.length > 0;
      const hasScores = (u.testscore !== undefined || u.score !== undefined) && (u.qlen !== undefined && u.qlen !== null);
      return hasPersonId || hasScores;
    });

    // Calculate test statistics using the difficulty attached to each attempt
    const totalUsers = validEntries.length;
    const passedUsers = validEntries.filter(user => {
      const correctAnswers = user.testscore || user.score || 0;
      const totalQuestions = user.qlen || 1;
      const attemptDifficulty = user.difficulty || defaultDifficulty;
      return calculateTestPassed(correctAnswers, totalQuestions, attemptDifficulty);
    }).length;

    // Calculate total LC earned — prefer stored lcEarned per attempt if present
    const totalPointsEarned = validEntries.reduce((total, user) => {
      if (typeof user.lcEarned === 'number') {
        return total + Number(user.lcEarned || 0);
      }
      const correctAnswers = user.testscore || user.score || 0;
      const totalQuestions = user.qlen || 1;
      const attemptDifficulty = user.difficulty || defaultDifficulty;
      const passed = calculateTestPassed(correctAnswers, totalQuestions, attemptDifficulty);
      const earnedLC = calculateLCEarned(correctAnswers, passed, attemptDifficulty);
      return total + earnedLC;
    }, 0);
    
          return (
        <React.Fragment>         
        {/* Test Difficulty Info */}
        {surveyMetadata && (
          <MDBContainer style={{marginBottom: '15px'}}>
            <MDBRow>
              <MDBCol style={{...table, textAlign: 'center', padding: '10px', backgroundColor: '#E3F2FD', border: '1px solid #2196F3', borderRadius: '5px'}}>
                <div style={{fontSize: '14px', fontWeight: 'bold', color: '#1976D2'}}>
                  Test Difficulty: {difficultyInfo.displayName} Level • {difficultyInfo.threshold}% Required to Pass
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        )}

        {/* Summary Statistics */}
        <MDBContainer style={{marginBottom: '20px'}}>
          <MDBRow>
            <MDBCol style={{...tableh, textAlign: 'center', padding: '15px', backgroundColor: '#4CAF50'}}>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: 'white'}}>
                {totalUsers}
              </div>
              <div style={{fontSize: '14px', color: 'white'}}>
                Total Users
              </div>
            </MDBCol>
            <MDBCol style={{...tableh, textAlign: 'center', padding: '15px', backgroundColor: '#2196F3'}}>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: 'white'}}>
                {passedUsers}
              </div>
              <div style={{fontSize: '14px', color: 'white'}}>
                Passed Tests
              </div>
            </MDBCol>
            <MDBCol style={{...tableh, textAlign: 'center', padding: '15px', backgroundColor: '#FF9800'}}>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: 'white'}}>
                {totalPointsEarned.toFixed(2)} LC
              </div>
              <div style={{fontSize: '14px', color: 'white'}}>
                Points Earned
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>

        {/* Detailed Results Table */}
        {survey_tests_list && Object.keys(survey_tests_list).length > 0 ? (
          <MDBContainer>

            
            {/* Table Header */}
            <MDBRow style={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
              <MDBCol style={{...tableh, border: '1px solid #ddd'}}>Name</MDBCol>
              <MDBCol style={{...tableh, border: '1px solid #ddd'}}>Score</MDBCol>
              <MDBCol style={{...tableh, border: '1px solid #ddd'}}>%</MDBCol>
              <MDBCol style={{...tableh, border: '1px solid #ddd'}}>Status</MDBCol>
              <MDBCol style={{...tableh, border: '1px solid #ddd'}}>LC Earned</MDBCol>
            </MDBRow>

            {/* Table Rows */}
            {validEntries.map((user, i) => {
              const correctAnswers = user.testscore || user.score || 0;
              const totalQuestions = user.qlen || 1;
              
              // Use each attempt's difficulty for calculations; prefer stored lcEarned when available
              const attemptDifficulty = (user && user.difficulty) ? user.difficulty : defaultDifficulty;
              const passed = calculateTestPassed(correctAnswers, totalQuestions, attemptDifficulty);
              const earnedLC = typeof user.lcEarned === 'number'
                ? Number(user.lcEarned || 0)
                : calculateLCEarned(correctAnswers, passed, attemptDifficulty);
              
              return (
                <MDBRow key={i} style={{borderBottom: '1px solid #eee'}}>
                  <MDBCol style={{...table, border: '1px solid #ddd'}}>
                    <b>{user.personname || `${user.firstName} ${user.lastName}` || 'Unknown'}</b>
                  </MDBCol>
                  <MDBCol style={{...table, border: '1px solid #ddd'}}>
                    {correctAnswers}/{totalQuestions}
                  </MDBCol>
                  <MDBCol style={{...table, border: '1px solid #ddd'}}>
                    {getPercentageScore(correctAnswers, totalQuestions)}
                  </MDBCol>
                  <MDBCol style={{...table, border: '1px solid #ddd', color: passed ? '#4CAF50' : '#f44336', fontWeight: 'bold'}}>
                    {passed ? '✅ PASSED' : '❌ FAILED'}
                  </MDBCol>
                  <MDBCol style={{...table, border: '1px solid #ddd', fontWeight: 'bold', color: earnedLC > 0 ? '#FF9800' : '#999'}}>
                    {earnedLC.toFixed(2)} LC
                  </MDBCol>
                </MDBRow>
              );
            })}
          </MDBContainer>
        ) : (
          <MDBContainer>
            <MDBRow>
              <MDBCol style={{...table, textAlign: 'center', padding: '20px', color: '#999'}}>
                No test results available yet. Users need to take the test first.
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        )}
      </React.Fragment> 
    )
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    survey_list: state.surveyList.survey_list,
    update_Survey: state.updateSurvey.update_Survey,
    survey_stats_list: state.surveyStat.survey_stats_list,
    simplething: state.simpleVal.simplething,
    survey_tests_list: state.surveyTes.survey_tests_list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createSurvey: params => dispatch(createSurvey(params)),
    updateSurvey: params => dispatch(updateSurvey(params)),
    surveyStats: params => dispatch(surveyStats(params)),
    simpleAction: params => dispatch(simpleAction(params)),
    surveyTestsDisplay: params => dispatch(surveyTestsDisplay(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyAllStats);


